import React, { useEffect } from 'react';

export default function TermsAndConditions() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://app.termly.io/embed-policy.min.js';
        script.id = 'termly-jssdk';
        document.body.appendChild(script);

        return () => {
            // Guard the removal: the Termly SDK (or any other teardown) may
            // have already detached this node, in which case removeChild throws
            // "node to be removed is not a child of this node" and surfaces as
            // an uncaught error during unmount. Only remove when still attached.
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return (
        <div>
            <div
                name="termly-embed"
                data-id="f93098d9-8396-4323-9ca5-77c7e0d1183b"
            />
        </div>
    );
}
